/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { textTransform } from 'utils';

export const BonusInfoWrapper = styled.div.attrs({
  className: 'bonus-info'
})`
  width: 100%;
  max-width: 1238px;
  margin: 0 auto;
  padding: 0 16px;

  .hall-ticket__title {
    display: inline-block;
    vertical-align: middle;
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: ${textTransform};
    margin: 24px 0 16px 0;
  }

  .container {
    padding: 0;
    overflow: hidden;
    background-color: #252525 !important;
    margin-bottom: 50px !important;
    padding-top: 37px !important;
  }
  
  .heading-1 {
    margin-bottom: 8px;
    text-transform: ${textTransform};
  }
`;

export const CloseBtn = styled.button.attrs({
  type: 'button'
})`
  
  position: absolute;
  margin-left: -4rem;
  float: right;
  margin-top: 20px;

  & > .svg-close {
    display: block;
    padding: 2px;
    fill: white;
    width: 30px;
    height: 30px;
    background-color: #474748;
    border-radius: 15px;
    transition: opacity 0.2s ease-out;
    opacity: 0.8;
    backface-visibility: hidden;
  }

  &:hover > .svg-close {
    opacity: 1;
  }
`;

export const Screen = styled.div.attrs({
  className: 'screen'
})`
  font-weight: 100;
  height: fit-content;

.screen_1{
  display: flex;
  height: fit-content;
  padding: 20px 0px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #323232;
  margin-left: 137px;
  margin-right: 155px;
}

.screen_1_first{
  min-width: 200px;
  min-height: 120px;
  font-size: 18px;
  line-height: 24px;
  /* font-family: 'Brandon' 'Grotesque'; */
  font-family:'Open Sans';
  font-style: Regular;  
  text-align: left;
}
.screen_1_second{
  cursor: pointer;
}

.screen-img{
  width:332px;
  height: 226px;
}

.screen-popup{
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  width:100%;
  height: 100%;
  left: 0%;
  top: 0%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: default;
}

.close-btn{
  float: right;
}

.screen-popup img{
  min-width: 300px;
}

.screen-img img{
  width:100%;
  height: 226px;
}

.screen_1, .screen_2{
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: space-evenly;
}

@media (min-width: 480px) {
  .screen-popup img{
    min-width: 500px;
  }
}

@media (min-width: 768px) {
  .screen_1, .screen_2{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap:50px;
  }
  .screen-popup img{
    min-width: 700px;
  }
}
`;

export const ScreenDetails = styled.div.attrs({
  className: 'screen-details'
})`
  /* font-family: 'Brandon' 'Grotesque'; */
  font-family: 'Open Sans';
  font-weight: 100;
  height: fit-content;
  padding: 45px 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: centre;
  justify-content: center;
  border-top: 3px solid #323232;

  .screen-details-card {
    width: 595px;
    min-height: 110px;
    padding: 8px 0px 8px 20px;
  }

  .letter-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .letter-pad {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 0px 0px 5px 5px;
    font-size: 14px;
  }

  .letter-pad img {
    width: 100%;
    height: 100%;
    margin-right: 10px;
  }

  .letter-pad2 {
    width: 44px;
    height: 20px;
    margin-right: 10px;
    border-radius: 0px 0px 5px 5px;
    font-size: 14px;
  }

  .letter-pad2 img {
    width: 100%;
    height: 100%;
    margin-right: 10px;
  }

  .screen-card-details {
    line-height: 20px;
    padding: 2px 0px;
    font-size: 14px;
  }

  .screen-card-heading2 {
    padding: 2px 0px;
    font-size: 14px;
    margin: 8px 0px 4px 0px;
    text-transform: ${textTransform};
  }

  .screen-heading {
    font-size: 18px;
  }

  .CinegoldSurpreme {
    color: #54a4f3;
  }

  .Cinegold {
    color: #debb69;
  }

  .LoveChair {
    color: #e94880;
  }

  .Cinegold {
    color: #debb69;
  }
`;
